import { MODAL_DATA, MODAL_CLOSE, HELP_CHANGE, ETL_HELP_CHANGE, ABOUT_CHANGE } from './../actions/modalOnChange';

const modalOnOpenReducer = (state = {}, { type, modelPayload }) => {
    switch (type) {
        case MODAL_DATA:
            return { ...state, modelPayload }
        default:
            return state
    }
};
const modalOnCloseReducer = (state = {}, { type, modelPayload }) => {
    switch (type) {
        case MODAL_CLOSE:
            return { ...state, modelPayload }
        default:
            return state
    }
};

const modalHelpOnChangeReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case HELP_CHANGE:
            return { ...state, payload }
        default:
            return state
    }
};

const modalAboutOnChangeReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case ABOUT_CHANGE:
            return { ...state, payload }
        default:
            return state
    }
};

const modalETLHelpOnChangeReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case ETL_HELP_CHANGE:
            return { ...state, payload }
        default:
            return state
    }
};
export { modalOnOpenReducer, modalOnCloseReducer, modalHelpOnChangeReducer, modalETLHelpOnChangeReducer, modalAboutOnChangeReducer };